module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('div', [_c('section', {
    staticClass: "sidebar"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("APPS")]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Dashaboard One",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Dashboard 1")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard-second"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Dashaboard Two",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Dashboard 2")], 1)], 1)])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mail"
    }
  }, [_c('i', {
    staticClass: "ti-email"
  }), _vm._v(" "), _c('span', [_vm._v("Mail Apps")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/chat"
    }
  }, [_c('i', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" "), _c('span', [_vm._v("Chat Apps")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/calendar"
    }
  }, [_c('i', {
    staticClass: "ti-calendar"
  }), _vm._v(" "), _c('span', [_vm._v("Calendar Apps")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/todo"
    }
  }, [_c('i', {
    staticClass: "ti-write"
  }), _vm._v(" "), _c('span', [_vm._v("ToDo Apps")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://devin.ndesaintheme.com"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Gradient",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Gradient Skin")], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://devin-dark.ndesaintheme.com"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Dark",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Dark Skin")], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://devin-light.ndesaintheme.com"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Light",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Light Skin")], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://devin-black.ndesaintheme.com"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Black",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Black Skin")], 1)])])]), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("PAGES")]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/blog-list"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Blog List",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Blog List ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/blog-mansory"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Blog Mansory",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Blog Mansory ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/blog-details"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Blog Details",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Blog Details ")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/shop-home"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "hop Home Page",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Shop Home ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop-item"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Shop Item",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Shop Item")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(5, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/invoice"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Invoice",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Invoice")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Profile",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Profile")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Login",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Login")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/404"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "404",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" 404 Error")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/500"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "500",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" 500 Error")], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": "/blank-page"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Blank Page",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Blank Page")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("GENERALS")]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(6, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/form/radio"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Radio",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Radio")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/form/checkbox"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Check Box",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Checkbox")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/form/input"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Input",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Input")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/form/select"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Select",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Select")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/form/cascader"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Cascader",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Cascader")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/form/switch"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Switch",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Switch")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/form/Slider"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Slider",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Slider")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/form/timepicker"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Time Picker",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Time Picker")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(7, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/chart/chartjs"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Chart Line",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Chart Line")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/chart-bar"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Chart Bar",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Chart Bar")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/chart-pie"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Chart Pie",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Chart Pie")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/chart/vuebar"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Radio",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Vue Bar")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(8, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/ui/ui-editor"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Editor",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Editor")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ui/ui-upload"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Upload",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Upload")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/UI/general"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "General",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" General")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/UI/icons"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Icons",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Icons")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/UI/buttons"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Buttons",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Buttons")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/UI/timeline"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Timeline",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Timeline")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/UI/modals"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Modals",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" Modals")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(9, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/simple-table"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Simple Table",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Simple Tables")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/select-table"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Select Table",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Select Tables")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/expandable-table"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Expandable Table",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Expandable Tables")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(10, false, false), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/gmap"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "GMaps API",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" GMaps API")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/open-layer"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "O P",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Open Layer")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/chart/chart-map"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Maps Vector",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Maps Vector")], 1)], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "header palette-Cyan-400 bg"
  }, [_vm._v("DEVIN VUE 1.2")]), _vm._v(" "), _vm._m(11, false, false), _vm._v(" "), _vm._m(12, false, false), _vm._v(" "), _vm._m(13, false, false), _vm._v(" "), _vm._m(14, false, false)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "static/img/avatar2.png",
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v("Good Job, Matirasa")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("You haven,t miss any task this week!")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-panel"
  }), _c('small', [_vm._v("Settings")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _c('small', [_vm._v("Profile")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _c('small', [_vm._v("Logout")])])])]), _vm._v(" "), _c('img', {
    staticClass: "bg-user",
    attrs: {
      "src": "static/img/avatar-bg.png",
      "alt": "User Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-desktop"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-paint-roller"
  }), _vm._v(" "), _c('span', [_vm._v("Skin")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-layout-accordion-list"
  }), _vm._v(" "), _c('span', [_vm._v("Blog")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart-full"
  }), _vm._v(" "), _c('span', [_vm._v("E Commerce")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-layout-media-overlay"
  }), _vm._v(" "), _c('span', [_vm._v("Common Page")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-write"
  }), _vm._v(" "), _c('span', [_vm._v("Forms")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Charts")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-folder"
  }), _vm._v(" "), _c('span', [_vm._v("UI Elements")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-layout"
  }), _vm._v(" "), _c('span', [_vm._v("Tables")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-location-pin"
  }), _vm._v(" "), _c('span', [_vm._v("Maps")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://ndesaintheme.com/devin/doc"
    }
  }, [_c('span', [_vm._v("Documentation")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa ti-agenda pull-right version"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("About")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa ti-info-alt pull-right version"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Feedback")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "version fa ti-package pull-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-380e1906!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 996
// module chunks = 2